// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".datetime-form[data-v-de3b992c]{display:flex;flex-direction:row;justify-content:space-between;align-items:center;width:100%}.datetime-item[data-v-de3b992c]{display:flex;flex-direction:column;width:calc(50% - 5px)}.label[data-v-de3b992c]{color:#000;font-weight:600;line-height:1.21429rem;margin-bottom:5px}[data-v-de3b992c] .mx-datepicker svg{display:none}[data-v-de3b992c] .mx-input{padding:12px 6px}", ""]);
// Exports
module.exports = exports;
